import * as http from "api/http";
import { SERVICES_URL, handleError } from "api/helper";
import { IReportCreateConfiguration } from "powerbi-models";
import { ConfigurationService } from "@adfenix/types";

export interface PowerBIReportConfig
  extends Omit<IReportCreateConfiguration, "type"> {
  type: "report";
}

interface AdfenixReportConfig {
  embedToken: { token: string; expiration: Date; tokenId: string };
  embedReport: PowerBIReportConfig[];
}

const get = http.get;
const baseUrl = "reporting/auth/v1/reporting";

export const getReportConfigsByHqOrOfficeId = ({
  id,
  getOfficeReport
}: {
  id: ConfigurationService.Hq["id"] | ConfigurationService.Office["id"];
  getOfficeReport: boolean;
}): Promise<AdfenixReportConfig> =>
  getOfficeReport
    ? get(`${SERVICES_URL}/${baseUrl}/embed/office/${id}`).catch(handleError)
    : get(`${SERVICES_URL}/${baseUrl}/embed/hq/${id}`).catch(handleError);
